import { gql } from '@grandvisionhq/graphql';

var GET_PREFERRED_STORE = gql`
  query getPreferredStoreCode {
    me {
      id
      preferredStore {
        code
      }
    }
  }
`;

export { GET_PREFERRED_STORE as default };
//# sourceMappingURL=get-preferred-store.js.map
